import dayjs from "dayjs";
import { useDateFormatStore } from "@/stores/DateFormatStore";

export const useDateTime = () => {
    const globalFormat = useDateFormatStore();
    const formattedDateTime = (dateTime: Date | string) => {
        return dayjs(dateTime).format(globalFormat.globalDateTimeFormat);
    };

    const formattedDateTimeEndOfDay = (dateTime: Date | string) => {
        return dayjs(dateTime).endOf("day").format(globalFormat.globalDateTimeFormat);
    };

    const formattedDate = (dateTime: Date | string) => {
        return dayjs(dateTime).format(globalFormat.globalDateFormat);
    };

    const isDate = (dateTime: Date | string) => {
        return dayjs(dateTime).isValid();
    };

    const dateIsInFuture = (futureDateTime: Date): boolean => {
        const now = dayjs();
        const future = dayjs(futureDateTime);

        return now.isBefore(future);
    };

    return {
        formattedDateTime,
        formattedDateTimeEndOfDay,
        formattedDate,
        isDate,
        dateIsInFuture,
    };
};
